import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { AlertApi } from '../../../apis/AlertApi/AlertApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';

export interface IAddAlertCommentVariables {
    id: number;
    comment: string;
}

export function useAddAlertComment() {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation<void, AppMedError, IAddAlertCommentVariables>({
        mutationKey: [QueryKeys.alerts, 'addComment'],
        mutationFn: async ({ id, comment }: IAddAlertCommentVariables) => {
            return await AlertApi.addComment(id, comment);
        },
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.alertDetail, variables.id] });
            notifications.show({
                title: t('notification.success'),
                message: t('alert.notifications.commentAdded'),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('notification.error'),
                message: error?.message || t('notification.error'),
                color: 'red',
            });
        },
    });
}
